import React from 'react'
import { Box, Typography } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { Button } from '../../../../interaxDesignSystemComponents'
import { Modal } from '../../../../shared/components/Modal'

interface ControlTowerConfirmDialogProps {
  isOpen: boolean
  title: string
  body: string
  cancelLabel: string
  confirmLabel: string
  isConfirming: boolean
  confirmTestId: string
  onCancel: () => void
  onConfirm: () => void
}

/** The are-you-sure step of a card action: the question, what it does, and the two answers. */
export const ControlTowerConfirmDialog: React.FC<ControlTowerConfirmDialogProps> = ({
  isOpen,
  title,
  body,
  cancelLabel,
  confirmLabel,
  isConfirming,
  confirmTestId,
  onCancel,
  onConfirm
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    title={title}
    maxWidth="sm"
    actions={
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <Button variant="secondary" disabled={isConfirming} onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant="primary" disabled={isConfirming} onClick={onConfirm} data-testid={confirmTestId}>
          {confirmLabel}
        </Button>
      </Box>
    }
  >
    <Typography sx={{ color: INTERAX_COLORS.white70, fontSize: '14px', lineHeight: '22px' }}>{body}</Typography>
  </Modal>
)
